module.exports = __webpack_public_path__ + "static/img/SketchPng013d354c64071fefb33e9dcfeb20c7ac87b4b4057809e1dbc1923c5bd64f9511.3747856.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SketchPng013d354c64071fefb33e9dcfeb20c7ac87b4b4057809e1dbc1923c5bd64f9511.png
// module id = icHe
// module chunks = 1